import React from 'react';
import { FDStack, FDTitleText } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import {
  GoalSummaryItem,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/components/GoalSummaryItem';
import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import {
  GoalSummaryItemLineItem,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/components/GoalSummaryItemLineItem';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import {
  GoalSummaryItemLineItemCollection,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/components/GoalSummaryItemLineCollection';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';

const GoalSummaryItemOverride = fr.metaOverride({ base: BaseOverride })
  .override({ readonly: true }, {
    _component: () => GoalSummaryItemLineItem,
  }, overrideReadOnly)
  .nameOverride('title', {
    hidden: false,
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('retirementOutcomes', {
    _component: () => GoalSummaryItemLineItemCollection,
  }, overrideReadOnly);

export function GoalSummaryLayout({ onAdd = noop, onEditItem = noop, onDeleteItem = noop }) {
  const { resource } = useMetaLayoutContext();

  const AddMoreGoalsButton = resource.withRelationship(fr.relationships.addOutcome.name,
    (rel) => <OnboardingAddItemButton relationship={rel} onAdd={async () => onAdd(rel)} />,
    () => null);

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'} width={'100%'}>
      <FDStack direction={'column'} spacing={2} alignItems={'center'} width={'100%'} maxWidth={425}>
        <MetaControlField attr={'title'} simpleRootStyle />
        <MetaControlField attr={'subtitle'} simpleRootStyle />
      </FDStack>
      <FDStack direction={'column'} spacing={3} alignItems={'center'} width={'100%'} maxWidth={600}>
        <MetaCollectionRenderer
          layout={GoalSummaryItem}
          LayoutProps={{
            onEditItem,
            onDeleteItem,
          }}
          collection={resource.attr('goals')}
          metaOverrideSet={GoalSummaryItemOverride}
        />
      </FDStack>
      {AddMoreGoalsButton}
    </FDStack>
  );
}

GoalSummaryLayout.propTypes = {
  onAdd: PropTypes.func,
  onEditItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
};
